import AElement from "aloha-vue/src/AElement/AElement";

import UiCheckbox from "../../../../../global/components/ui/UiCheckbox/UiCheckbox.vue";

import UIComponentMixin from "../../../../../global/components/ui/UIComponentMixin";

import MainAPI from "./CompositionAPI/mainAPI";
import CurrentIconsAPI from "./CompositionAPI/currentIconsAPI";

import {
  filter,
  some,
} from "lodash-es";


// @vue/component
export default {
  name: "UiObjekticonVergabeConfigSelection",
  components: {
    AElement,
    UiCheckbox,
  },
  mixins: [
    UIComponentMixin,
  ],
  props: {
    model: {
      type: [String, Array, Number],
      default: undefined,
    },
    dependencyValue: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  setup(props) {
    const {
      allIcons,
      loading,
      loadObjekticons,
    } = MainAPI(props);

    const {
      currentIcons
    } = CurrentIconsAPI(props, {
      allIcons,
    });

    loadObjekticons();

    return {
      allIcons,
      currentIcons,
      loading,
      loadObjekticons,
    };
  },
  computed: {
    checkboxOptions() {
      return {
        id: `${ this.options.id }_selection`,
        required: true,
        keyId: "pk",
      };
    }
  },
  watch: {
    dependencyValue: function() {
      this.dependencyUpdateSelection();
    },
  },
  methods: {
    dependencyUpdateSelection() {
      const MODEL = filter(this.model, oic_id => some(this.currentIcons, oic => oic.pk === oic_id));
      this.input({
        id: this.options.id,
        currentModel: MODEL,
        model: MODEL,
        options: this.options,
      });

      this.change({
        id: this.options.id,
        currentModel: MODEL,
        model: MODEL,
        options: this.options,
      });
    },
  },
};
